import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import * as fb from 'firebase'



Vue.config.productionTip = false

new Vue({
	render: h => h(App),
	router,
	store,
	created () {
		fb.initializeApp ({
			apiKey: "AIzaSyCJ7t9LgqMfiJGT35hi4kryxeE88uVayQE",
			authDomain: "hlebgridnev.firebaseapp.com",
			databaseURL: "https://hlebgridnev.firebaseio.com",
			projectId: "hlebgridnev",
			storageBucket: "hlebgridnev.appspot.com",
			messagingSenderId: "730512360322",
			appId: "1:730512360322:web:bc7c877c9e810e923f859b"
			})
	}
}).$mount('#app')
